<clr-modal
  [clrModalOpen]="isModalOpen()"
  (clrModalOpenChange)="isModalOpen.set($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'lg'">
  <h3 class="modal-title">
    {{ 'Tabelle verwalten' | mrTranslate }}
    @if (route().title; as title) {
      : {{ title }}
    }
  </h3>
  <div class="modal-body full-height d-f col gap-5 clr-justify-content-between clr-align-items-stretch">
    @if (isLoadingNames()) {
      <clr-spinner class="centred" />
    } @else {
      <div
        class="d-f width100 clr-flex-column clr-flex-sm-row clr-align-items-stretch clr-align-items-sm-start gap-10 w-100-p">
        <div class="btn-group btn-icon">
          <button
            class="btn"
            [disabled]="isNeu()"
            (click)="isNeu.set(true); selectedName.set(null); bezeichnung.reset()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="file" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Baugruppe erstellen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
          @if (!isRep) {
            <button
              class="btn btn-danger"
              [disabled]="!selectedName() || isNeu() || isCopy()"
              (click)="deleteBaugruppe()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="times" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Baugruppe löschen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
        </div>
        @if (isRename()) {
          <form clrForm class="nm flex-1-10-auto width100" (ngSubmit)="onSubmit()">
            <clr-input-container class="nm flex-1-10-auto">
              <label class="clr-required-mark">{{ 'Name' | mrTranslate }}</label>
              <input clrInput type="text" [formControl]="bezeichnung" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Erforderlich' | mrTranslate }}
              </clr-control-error>
              <clr-control-error *clrIfError="'pattern'">
                {{ 'Mit Buchstabe anfangen' | mrTranslate }}
              </clr-control-error>
            </clr-input-container>
          </form>
        } @else {
          <clr-select-container class="nm flex-1-10-auto">
            <label>{{ 'Baugruppe' | mrTranslate }}</label>
            <select clrSelect [(ngModel)]="selectedName" [ngModelOptions]="{ standalone: true }">
              <option [value]="undefined" disabled>{{ 'Baugruppe auswählen' }}</option>
              @for (name of names(); track $index) {
                <option [value]="name">{{ name }}</option>
              }
            </select>
          </clr-select-container>
        }
        <div class="btn-group btn-icon">
          @if (isNeu() || isCopy()) {
            <button class="btn btn-warning" (click)="isNeu.set(false); isCopy.set(false)">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="times-circle" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Abbrechen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          } @else if (isRename()) {
            <button
              class="btn btn-success"
              [disabled]="bezeichnung.invalid"
              (click)="renameBaugruppe()"
              [clrLoading]="loadState()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="floppy" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Baugruppe umbennenen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
            <button class="btn btn-warning" (click)="isRename.set(false)">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="times-circle" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Abbrechen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          } @else {
            <button class="btn" [disabled]="!selectedName()" (click)="isRename.set(true)">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="pencil" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Baugruppe umbennenen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
            <button class="btn" [disabled]="!selectedName()" (click)="isCopy.set(true)">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="copy" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Baugruppe kopieren' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
        </div>
      </div>
    }
    @if (isLoadingPruefarten()) {
      <clr-spinner class="centred" />
    } @else if (pruefarten().length || isNeu()) {
      @if (f.submitted && form.errors?.['required']) {
        <clr-alert clrAlertType="danger" [clrAlertClosable]="false">
          <clr-alert-item>
            <span class="alert-text">{{ 'Mindestens ein Prüfart' | mrTranslate }}</span>
          </clr-alert-item>
        </clr-alert>
      }

      <form
        id="bauartgruppe-form"
        clrForm
        autocomplete="off"
        #f="ngForm"
        [formArray]="form"
        (ngSubmit)="onSubmit()"
        class="width100 w-100-p flex-1-1-auto scroll-y">
        @for (group of form.controls; track $index) {
          <div class="d-f row gap-5 w-100-p clr-align-items-baseline row-group" [formGroupName]="$index">
            @if (!isRep || !group.value.ID) {
              <button type="button" class="btn btn-icon btn-danger-outline" (click)="deletePruefart($index)">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="times" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Prüfart löschen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
            <clr-input-container class="pruefart nm">
              <label class="clr-required-mark">{{ 'Prüfart' | mrTranslate }}</label>
              <input type="text" clrInput formControlName="Pruefart" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Erforderlich' | mrTranslate }}
              </clr-control-error>
            </clr-input-container>

            <clr-number-input-container class="anzahl nm">
              <label class="clr-required-mark">{{ 'Anzahl' | mrTranslate }}</label>
              <input type="number" clrNumberInput formControlName="Anzahl" />
              <clr-control-error *clrIfError="'required'">
                {{ 'Erforderlich' | mrTranslate }}
              </clr-control-error>
              @if (group.controls.Anzahl.errors?.min) {
                <clr-control-error>{{ 'Mindestens' | mrTranslate }} 0</clr-control-error>
              }
            </clr-number-input-container>
          </div>
        }
        <div class="btn-group btn-icon margin-24-tb">
          <button type="button" class="btn" (click)="addPruefart()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="plus" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Prüfart hinzufügen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
          @if (!isImported()) {
            <button type="button" class="btn" (click)="addDefaultPruefarts()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="import" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Vorlage benutzen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
        </div>
      </form>

      <button
        type="submit"
        form="bauartgruppe-form"
        class="btn btn-success"
        style="max-width: none; min-height: 32px"
        [clrLoading]="loadState()">
        {{ (isNeu() || isCopy() ? 'Erstellen' : 'Speichern') | mrTranslate }}
      </button>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isModalOpen.set(false)">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
